var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriggers = function SvgTriggers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Triggers_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Triggers_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 26,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.369 1.778v10.94h9.258L12.993 30.224v-10.94H3.733L17.37 1.778Z",
    stroke: "#14161A",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Triggers_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0V0Z",
    fill: "#B7BFC8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Triggers_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export { SvgTriggers as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyNDI3XzUwODcxNykiPgo8bWFzayBpZD0ibWFzazBfMTI0MjdfNTA4NzE3IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIyIiB5PSIwIiB3aWR0aD0iMjYiIGhlaWdodD0iMzIiPgo8cGF0aCBkPSJNMTcuMzY4NiAxLjc3ODMyVjEyLjcxODVIMjYuNjI2N0wxMi45OTI1IDMwLjIyMjhWMTkuMjgyNkgzLjczNDM4TDE3LjM2ODYgMS43NzgzMloiIHN0cm9rZT0iIzE0MTYxQSIgc3Ryb2tlLXdpZHRoPSIyLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMTI0MjdfNTA4NzE3KSI+CjxwYXRoIGQ9Ik0wIDBIMzJWMzJIMFYwWiIgZmlsbD0iI0I3QkZDOCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTI0MjdfNTA4NzE3Ij4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";